/**
 * Analytics Configuration
 * Defines which routes should be tracked for analytics
 */

// Track all routes - no filtering
// All module navigation will be tracked
export const TRACKED_ROUTES = null // This means track everything

// Analytics settings
export const ANALYTICS_CONFIG = {
    endpoint: `${process.env.VUE_APP_FACTORYBASE_API_URI}/loggers/module-entrance-analytics`,
    retryAttempts: 3,
    retryDelayMs: 1000,
    debounceDelayMs: 500,
    // Enable/disable analytics based on environment
    enabled: process.env.VUE_APP_ENABLE_ANALYTICS === 'true',
}
